// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__ZODFb {
  width: 100%;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0px 0px 8px 0px rgba(68, 87, 104, 0.25);
  padding: 10px; }

.styles_container__xFhDW {
  display: flex;
  margin-bottom: 20px;
  padding-left: 10px;
  position: relative;
  border-bottom: none;
  box-sizing: border-box;
  width: 100%; }
  .styles_container__xFhDW .styles_container_underline__6cjtr {
    flex-grow: 1;
    border-bottom: 1px solid var(--Gray85); }
    .styles_container__xFhDW .styles_container_underline__6cjtr::marker {
      color: transparent; }

.styles_tab__d150r {
  min-width: 122px;
  position: relative;
  padding: 10px 20px;
  list-style-type: none;
  cursor: pointer;
  text-align: center;
  -webkit-user-select: none;
          user-select: none;
  box-sizing: border-box;
  border: 1px solid transparent; }
  .styles_tab_active__thYoi {
    border: 1px solid var(--LowEmphasis);
    border-radius: 4px 4px 0px 0px;
    border-bottom: none; }
  .styles_tab_nonActive__iTz6X {
    color: #9E9E9E;
    border-bottom: 1px solid var(--Gray85); }
`, "",{"version":3,"sources":["webpack://./src/pages/info/task/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mDAAmD;EACnD,aAAa,EAAA;;AAGf;EACI,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW,EAAA;EAPf;IASM,YAAY;IACZ,sCAAsC,EAAA;IAV5C;MAaQ,kBAAkB,EAAA;;AAKxB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,sBAAsB;EACtB,6BAA6B,EAAA;EAC7B;IACE,oCAAoC;IACpC,8BAA8B;IAC9B,mBAAmB,EAAA;EAGrB;IACE,cAAa;IACb,sCAAsC,EAAA","sourcesContent":[".wrapper {\n  width: 100%;\n  border-radius: 4px;\n  background: #fff;\n  box-shadow: 0px 0px 8px 0px rgba(68, 87, 104, 0.25);\n  padding: 10px;\n}\n\n.container {\n    display: flex;\n    margin-bottom: 20px;\n    padding-left: 10px;\n    position: relative;\n    border-bottom: none;\n    box-sizing: border-box;\n    width: 100%;\n    .container_underline {\n      flex-grow: 1;\n      border-bottom: 1px solid var(--Gray85);\n  \n      &::marker {\n        color: transparent;\n      }\n    }\n  }\n  \n  .tab {\n    min-width: 122px;\n    position: relative;\n    padding: 10px 20px;\n    list-style-type: none;\n    cursor: pointer;\n    text-align: center;\n    user-select: none;\n    box-sizing: border-box;\n    border: 1px solid transparent;\n    &_active {\n      border: 1px solid var(--LowEmphasis);\n      border-radius: 4px 4px 0px 0px;\n      border-bottom: none;\n      }\n  \n    &_nonActive {\n      color:#9E9E9E;\n      border-bottom: 1px solid var(--Gray85);\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__ZODFb`,
	"container": `styles_container__xFhDW`,
	"container_underline": `styles_container_underline__6cjtr`,
	"tab": `styles_tab__d150r`,
	"tab_active": `styles_tab_active__thYoi`,
	"tab_nonActive": `styles_tab_nonActive__iTz6X`
};
export default ___CSS_LOADER_EXPORT___;
